// extracted by mini-css-extract-plugin
export default {"th":"WalletFixasList_th__PCK2w","td":"WalletFixasList_td__g-Y8u"};